import React, { useEffect, useRef, useState } from "react";
import Topbar from "../Topbar/Topbar";
import "./Recoverystyle.css";
import { Col, Container, Row } from "react-bootstrap";
import { FaStarOfLife } from "react-icons/fa6";
import { FiUpload } from "react-icons/fi";
import { MdEdit } from "react-icons/md";
import { MdOutlineAssignmentInd } from "react-icons/md";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import MessageBox from "../MessageBox/MessageBox";
import { sendNotification } from "../../utils/notification"; // Adjust the import path as necessary

const fileTypes = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "application/pdf",
  "application/msword", // .doc
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
  "application/vnd.oasis.opendocument.text", // .odt
  "text/plain", // .txt
  "application/vnd.ms-excel", // .xls
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "message/rfc822", // .eml
  "application/vnd.ms-outlook", // .msg
  "application/octet-stream", // fallback
];

const AddRecovery = () => {
  //message box
  const staffName = useSelector((state) => state.staffname);
  const Id = useSelector((state) => state.id);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const fileInputRef = useRef();

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const permissions = useSelector((state) => state.permissions);

  const navigate = useNavigate();
  const [customerId, setCustomerId] = useState("");
  const [customerData, setCustomerData] = useState(null);
  const [errorLocation, setErrorLocation] = useState("");
  const [error, setError] = useState("");
  const [isOpenConverted, setIsOpenConverted] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [originalRecovery, setOriginalRecovery] = useState(null);
  const [isOpenAssign, setIsOpenAssign] = useState(false);
  const [routerTypes, setRouterTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [routerError, setRouterError] = useState(null);
  // Staff data and selection states
  const [staffData, setStaffData] = useState([]);
  const [staffNameFetch, setStaffNameFetch] = useState([]);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [selectedApprover, setSelectedApprover] = useState([]);
  const [isStaffDropdownOpen, setIsStaffDropdownOpen] = useState(false);
  const [isApproverDropdownOpen, setIsApproverDropdownOpen] = useState(false);

  const staffDropdownRef = useRef(null);
  const approverDropdownRef = useRef(null);
  const [recoveryId, setRecoveryId] = useState(null); // Add this to your component
  // Task data state
  const [taskData, setTaskData] = useState({
    taskName: "Recovery",
    assignedBy: staffName,
    assignDateTime: new Date().toISOString().slice(0, 16),
    taskType: "Once",
    taskPriority: "Low",
    deadline: "",
    time: "",
    assignedTo: [],
    approvePerson: "",
    description: "",
    leadId: "",
    name: "",
    taskStatus: "Open",
  });

  // Recovery data state
  const [recoveryData, setRecoveryData] = useState({
    createdDate: "",
    customerid: "",
    customername: "",
    address: "",
    contactnum: "",
    alternatenum: "",
    location: "",
    area: "",
    routertype: "",
    leadStatus: "Open",
    recoveryleadStatus: {
      nextFollowUpDate: "",
      recoverynotes: "",
      recoveryimage: "",
    },
  });

  // Current date state
  const [currentDate, setCurrentDate] = useState("");

  // Set current date on component mount
  useEffect(() => {
    const date = new Date();
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const formattedDate = `${day}-${month}-${year}`;
    setCurrentDate(formattedDate);
    setTaskData((prev) => ({
      ...prev,
      assignDateTime: date.toISOString().slice(0, 16),
      leadId: customerId,
      name: customerData?.customername || "",
    }));
  }, [customerId, customerData]);

  // Fetch staff data

  useEffect(() => {
    axios
      .get(apiUrl + "get-staff-names")
      .then((res) => {
        if (res.data.message) {
          setStaffNameFetch(res.data.message); // names = array of objects like { _id, staffName }
        }
      })
      .catch((err) => {
        console.log("Error fetching staff names:", err);
      });
  }, []);
  // Fetch staff all data
  useEffect(() => {
    axios
      .post(
        apiUrl + "viewstaff",

        {}
      )
      .then((res) => {
        setStaffData(res.data.message);

        console.log(res.data.message);
      });
  }, [apiUrl]);

  // Fetch customer data when customerId changes
  useEffect(() => {
    const fetchCustomerDataByNumericId = () => {
      if (!customerId.trim()) {
        setCustomerData(null);
        setError("");
        return;
      }

      axios
        .get(`${apiUrl}get-customer-by-numeric-id/${customerId}`)
        .then((response) => {
          if (response.data.success) {
            const data = response.data.data;
            setCustomerData(data);
            setError("");
            setRecoveryData((prev) => ({
              ...prev,
              customerid: customerId,
              customername: data.installcustomerName || "",
              contactnum: data.installcontactNum || "",
              alternatenum: data.installalternateNum || "",
              address: data.installaddress || "",
              area: data.area || "",
              location: data.location?.latitude ? `${data.location.latitude}, ${data.location.longitude}` : "",
            }));
          } else {
            setError("Customer not found");
            setCustomerData(null);
          }
        })
        .catch((err) => {
          if (err.response?.status === 404) {
            setError("Customer not found");
          } else {
            setError("An error occurred.");
          }
          setCustomerData(null);
        });
    };

    fetchCustomerDataByNumericId();
  }, [customerId, apiUrl]);

  // Handle recovery form changes
  // const handleRecoveryChange = (e) => {
  //   const { name, value } = e.target;

  //   if (name in recoveryData.recoveryleadStatus) {
  //     setRecoveryData((prev) => ({
  //       ...prev,
  //       recoveryleadStatus: {
  //         ...prev.recoveryleadStatus,
  //         [name]: value,
  //       },
  //     }));
  //   } else {
  //     setRecoveryData((prev) => ({
  //       ...prev,
  //       [name]: value,
  //     }));
  //   }
  // };
  const handleRecoveryChange = (e) => {
    const { name, value } = e.target;

    // Handle fields inside `recoveryleadStatus`
    if (name in recoveryData.recoveryleadStatus) {
      setRecoveryData((prev) => ({
        ...prev,
        recoveryleadStatus: {
          ...prev.recoveryleadStatus,
          [name]: value,
        },
      }));
      return; // Exit early for fields inside `recoveryleadStatus`
    }

    // Handle `location` field
    if (name === "location") {
      const latLngRegex =
        /^-?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*-?(180(\.0+)?|((1[0-7]\d)|(\d{1,2}))(\.\d+)?)$/;

      // Validate location and update error state
      if (value.trim() === "" || latLngRegex.test(value)) {
        setErrorLocation(""); // Clear error for valid or empty input
      } else {
        setErrorLocation(
          "Please enter a valid location, e.g., 12.123456,23.456789"
        );
      }

      // Split the value into latitude and longitude if valid
      const [latitude, longitude] = value
        .split(",")
        .map((coord) => coord.trim());

      setRecoveryData((prev) => ({
        ...prev,
        location: value, // Store full string
        latitude: latitude || null, // Store latitude separately
        longitude: longitude || null, // Store longitude separately
      }));

      return; // Exit early for `location` field
    }

    // Handle all other fields
    setRecoveryData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };



    const formatDateTimeLocal = (date) => {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
  
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  
  
  
  useEffect(() => {
    if (taskData.assignDateTime) {
      const assignDate = new Date(taskData.assignDateTime);
      const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000); // +4 hours
      const formattedDeadline = formatDateTimeLocal(deadlineDate);
  
      setTaskData(prev => ({
        ...prev,
        deadline: formattedDeadline
      }));
    }
  }, [taskData.assignDateTime]);
  
  
  
  
  
  const handleTaskChange  = (field, value) => {
    if (field === 'assignDateTime') {
      const assignDate = new Date(value);
      const deadlineDate = new Date(assignDate.getTime() + 4 * 60 * 60 * 1000);
      const formattedDeadline = deadlineDate.toISOString().slice(0, 16);
  
      setTaskData(prev => ({
        ...prev,
        assignDateTime: value,
        deadline: formattedDeadline // auto update
      }));
    } else {
      setTaskData(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };
  

  // // Handle task form changes
  // const handleTaskChange = (field, value) => {
  //   setTaskData((prev) => ({
  //     ...prev,
  //     [field]: value,
  //   }));
  // };

  // Toggle staff dropdown
  const toggleStaffDropdown = () => {
    setIsStaffDropdownOpen((prev) => !prev);
  };

  // Toggle approver dropdown
  const toggleApproverDropdown = () => {
    setIsApproverDropdownOpen((prev) => !prev);
  };

  // Handle staff selection
  const handleStaffSelection = (staff) => {
    setSelectedStaff((prev) =>
      prev.some((s) => s._id === staff._id)
        ? prev.filter((s) => s._id !== staff._id)
        : [...prev, staff]
    );
  };

  // Handle approver selection
  const handleApproverSelection = (staff) => {
   setSelectedApprover((prev) =>
      prev.some((s) => s._id === staff._id)
        ? prev.filter((s) => s._id !== staff._id)
        : [...prev, staff]
    );
  };

  // Get display text for selected staff
  const getStaffDisplayText = () => {
    return selectedStaff.length > 0
      ? selectedStaff.map((staff) => staff.staffName).join(", ")
      : "Select staff";
  };

  // Get display text for selected approver
  // const getApproverDisplayText = () => {
  //   return selectedApprover.length > 0
  //     ? selectedApprover[0].staffName
  //     : "Select approver";
  // };
   const getApproverDisplayText = () => {
    return selectedApprover.length > 0
      ? selectedApprover.map((staff) => staff.staffName).join(", ")
      : "Select Approve Persons";
  };
  

  // const [selectedFiles, setSelectedFiles] = useState([]);
  // const handleFiles = (files) => {
  //   const fileArray = Array.from(files);
  //   setSelectedFiles(fileArray); // Save in state for later FormData usage
  // };

//   const handleRecoverySubmit = async (e) => {
//     e.preventDefault();

//     const result = await Swal.fire({
//       title: "Do you want to submit the Recovery Details?",
//       showCancelButton: true,
//       confirmButtonText: "Submit",
//     });

//     if (!result.isConfirmed) return;

//     try {
//       const now = new Date();
//       const date = now.toLocaleDateString();
//       const time = now.toLocaleTimeString();

//       const dataToSubmit = {
//         ...recoveryData,
//         createdDate: recoveryData.createdDate || currentDate,
//         customerid: customerData.customerid || recoveryData.customerid,
//         customername:
//           customerData.customername || recoveryData.customername || "",
//         contactnum: customerData.contactnum || recoveryData.contactnum || "",
//         alternatenum:
//           customerData.alternatenum || recoveryData.alternatenum || "",
//         address:
//           customerData.installationadd || recoveryData.installationadd || "",
//         area: customerData.area || recoveryData.area || "",
//         location: recoveryData.location || "",
//         routertype: recoveryData.routertype || "",
//         leadStatus: recoveryData.leadStatus || "Open",
//         assignedBy: staffName,
//         recoveryleadStatus: {
//           nextFollowUpDate:
//             recoveryData.recoveryleadStatus?.nextFollowUpDate || "",
//           recoverynotes: recoveryData.recoveryleadStatus?.recoverynotes || "",
//           recoveryimage: recoveryData.recoveryleadStatus?.recoveryimage || "",
//         },
//         createdBy: {
//           staffName: staffName,
//           _id: Id,
//           date,
//           time,
//         },
//       };
//       console.log("Recovery Data to Submit:", dataToSubmit);
//       const recoveryRes = await axios.post(
//         apiUrl + "recovery-add",
//         dataToSubmit
//       );
//       const savedId = recoveryRes.data.data?._id;
//       setRecoveryId(savedId);

//       const formData = new FormData();
//       formData.append("pageRefId", savedId);
//       formData.append("page", "Recovery");
//       formData.append("colorCode", "#fbdc6e");
//       formData.append(
//         "description",
//         recoveryData.recoveryleadStatus?.recoverynotes || ""
//       );
//       formData.append("staffPic", "");
// if (selectedFile) {
//         formData.append("image", selectedFile);
//       }

//       formData.append("updatesHistory[staff][name]", staffName);
//       formData.append("updatesHistory[staff][id]", Id);
//       formData.append("updatesHistory[status]", recoveryData.leadStatus);

//       await axios.post(apiUrl + "add-message", formData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       const messagesRes = await axios.get(`${apiUrl}messages/${savedId}`);
//       setMessageData(messagesRes.data.data);
//       setShowMessageBox(true);

//       Swal.fire("Success!", "Recovery Details Submitted", "success");
//       setIsSubmitted(true);
//       setIsEditMode(false);
//     } catch (error) {
//       console.error("Error while submitting Recovery data", error);
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: error?.response?.data?.message || "Something went wrong!",
//       });
//     }
//   };



const handleRecoverySubmit = async (e) => {
  e.preventDefault();

  const result = await Swal.fire({
    title: "Do you want to submit the Recovery Details?",
    showCancelButton: true,
    confirmButtonText: "Submit",
  });

  if (!result.isConfirmed) return;

  try {
    const now = new Date();
    const date = now.toLocaleDateString();
    const time = now.toLocaleTimeString();

    const dataToSubmit = {
      ...recoveryData,
      createdDate: recoveryData.createdDate || currentDate,
      customerid: customerId || recoveryData.customerid,
      customername: recoveryData.customername || "",
      contactnum: recoveryData.contactnum || "",
      alternatenum: recoveryData.alternatenum || "",
      address: recoveryData.address || "",
      area: recoveryData.area || "",
      location: recoveryData.location || "",
      routertype: recoveryData.routertype || "",
      leadStatus: recoveryData.leadStatus || "Open",
      assignedBy: staffName,
      recoveryleadStatus: {
        nextFollowUpDate: recoveryData.recoveryleadStatus?.nextFollowUpDate || "",
        recoverynotes: recoveryData.recoveryleadStatus?.recoverynotes || "",
        recoveryimage: recoveryData.recoveryleadStatus?.recoveryimage || "",
      },
      createdBy: {
        staffName: staffName,
        _id: Id,
        date,
        time,
      },
    };

    // Main submission
    const recoveryRes = await axios.post(apiUrl + "recovery-add", dataToSubmit);
    const savedId = recoveryRes.data.data?._id;

    setRecoveryId(savedId);

    // Show popup for main success
    Swal.fire("Success!", "Recovery Details Submitted", "success");
    setIsSubmitted(true);
    setIsEditMode(false);

    // Optional: background message/image upload
    try {
      const formData = new FormData();
      formData.append("pageRefId", savedId);
      formData.append("page", "Recovery");
      formData.append("colorCode", "#fbdc6e");
      formData.append("description", recoveryData.recoveryleadStatus?.recoverynotes || "no description");
      formData.append("staffPic", "");

      if (selectedFile) {
        formData.append("image", selectedFile);
      }

      formData.append("updatesHistory[staff][name]", staffName);
      formData.append("updatesHistory[staff][id]", Id);
      formData.append("updatesHistory[status]", recoveryData.leadStatus|| "Open");

      await axios.post(apiUrl + "add-message", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      const messagesRes = await axios.get(`${apiUrl}messages/${savedId}`);
      setMessageData(messagesRes.data.data);
      setShowMessageBox(true);
    } catch (uploadError) {
      console.warn("Optional step failed: message/image upload", uploadError);
      // No Swal here, silently fails
    }
  } catch (error) {
    console.error("Error during recovery-add", error);
    Swal.fire({
      icon: "error",
      title: "Recovery Submission Failed",
      text: error?.response?.data?.message || "Something went wrong during Recovery Add",
    });
  }
};

  const handleSave = async () => {
    try {
      if (!recoveryData.customerid) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Customer ID is missing!",
        });
        return;
      }

      // Process location data - ensure it's always an object
      // const processLocation = () => {
      //   if (!recoveryData.location) return null;

      //   // If already an object with coordinates
      //   if (
      //     typeof recoveryData.location === "object" &&
      //     !Array.isArray(recoveryData.location)
      //   ) {
      //     return recoveryData.location;
      //   }

      //   // If it's a string like "80.123456,90.09890"
      //   if (typeof recoveryData.location === "string") {
      //     const [latitude, longitude] = recoveryData.location
      //       .split(",")
      //       .map(Number);
      //     if (!isNaN(latitude) && !isNaN(longitude)) {
      //       return {
      //         type: "Point",
      //         coordinates: [longitude, latitude], // GeoJSON format
      //         address: recoveryData.address || "",
      //       };
      //     }
      //     return { address: recoveryData.location };
      //   }

      //   return null;
      // };

      const payload = {
        ...recoveryData,
        customername:
          recoveryData.customername || customerData?.customername || "",
        createdDate: recoveryData.createdDate || currentDate,
        contactnum: customerData.contactnum || recoveryData.contactnum || "",
        alternatenum:
          customerData.alternatenum || recoveryData.alternatenum || "",
        address:
          customerData.installationadd || recoveryData.installationadd || "",
        // location: processLocation(), // Processed location object
        location: "",
        recoveryleadStatus: {
          nextFollowUpDate:
            recoveryData.recoveryleadStatus?.nextFollowUpDate || "",
          recoverynotes: recoveryData.recoveryleadStatus?.recoverynotes || "",
          recoveryimage: recoveryData.recoveryleadStatus?.recoveryimage || "",
        },
      };

      // Remove MongoDB-specific fields if present
      delete payload._id;
      delete payload.__v;

      const response = await axios.put(
        `${apiUrl}/recovery-update/${recoveryData.customerid}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          transformRequest: [(data) => JSON.stringify(data)], // Explicit stringify
        }
      );

      // Verify the response
      console.log("API Response:", response.data);
      if (typeof response.data.data?.location === "string") {
        console.warn("Warning: Backend is still returning location as string");
      }

      Swal.fire({
        title: "Recovery Details Updated Successfully!",
        icon: "success",
        draggable: true,
      });
      setIsEditMode(false);
    } catch (error) {
      console.error("Error updating recovery:", error);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text:
          error.response?.data?.message || "Something went wrong while saving!",
      });
    }
  };

  // Handle cancel edit
  const handleCancel = () => {
    if (originalRecovery) {
      setRecoveryData(JSON.parse(JSON.stringify(originalRecovery)));
    }
    setIsEditMode(false);
  };

  //Handle assign task submission
  const handleSubmitAssignTask = async (e) => {
    e.preventDefault();

    if (selectedStaff.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Data",
        text: "Please select at least one staff member to assign",
      });
      return;
    }

    if (selectedApprover.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Incomplete Data",
        text: "Please select an approver",
      });
      return;
    }

    Swal.fire({
      title: "Are you sure you want to create this task?",
      showCancelButton: true,
      confirmButtonText: "Submit",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const now = new Date();
          const day = String(now.getDate()).padStart(2, "0");
          const month = String(now.getMonth() + 1).padStart(2, "0");
          const year = now.getFullYear();
          const updatedDate = `${day}-${month}-${year}`;

          let hours = now.getHours();
          const minutes = String(now.getMinutes()).padStart(2, "0");
          const ampm = hours >= 12 ? "PM" : "AM";
          hours = hours % 12 || 12;
          const updatedTime = `${hours}:${minutes} ${ampm}`;

          const taskToSubmit = {
            ...taskData,
            assignedBy: {
              staffName: staffName,
              id: Id,
            },
            assignedTo: selectedStaff,
            approvePerson: selectedApprover,
            updatedDate,
            updatedTime,
            leadId: customerId,
            name: customerData?.customername || "",
            customerid: customerId,
            collectionId: recoveryId,
          };

          const response = await axios.post(
            apiUrl + "add-assign-task",
            taskToSubmit,
            { headers: { "Content-Type": "application/json" } }
          );

          Swal.fire({
            title: "Task Created Successfully!",
            icon: "success",
          }).then(() => {
            setIsOpenAssign(false);
            navigate("/task");
          });
        } catch (error) {
          console.error("Error submitting task:", error);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: error.response?.data?.message || "Something went wrong!",
          });
        }
      }
    });
  };
// const handleSubmitAssignTask = async (e) => {
//   e.preventDefault();

//   // ✅ Validation
//   if (selectedStaff.length === 0) {
//     Swal.fire({
//       icon: "warning",
//       title: "Incomplete Data",
//       text: "Please select at least one staff member to assign",
//     });
//     return;
//   }

//   if (selectedApprover.length === 0) {
//     Swal.fire({
//       icon: "warning",
//       title: "Incomplete Data",
//       text: "Please select an approver",
//     });
//     return;
//   }

//   const result = await Swal.fire({
//     title: "Are you sure you want to create this task?",
//     showCancelButton: true,
//     confirmButtonText: "Submit",
//   });

//   if (!result.isConfirmed) return;

//   try {
//     // ✅ Prepare Date & Time
//     const now = new Date();
//     const day = String(now.getDate()).padStart(2, "0");
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     const year = now.getFullYear();
//     const updatedDate = `${day}-${month}-${year}`;

//     let hours = now.getHours();
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     const ampm = hours >= 12 ? "PM" : "AM";
//     hours = hours % 12 || 12;
//     const updatedTime = `${hours}:${minutes} ${ampm}`;

//     // ✅ Task Payload
//     const taskToSubmit = {
//       ...taskData,
//       assignedBy: {
//         staffName,
//         id: Id,
//       },
//       assignedTo: selectedStaff,
//       approvePerson: selectedApprover,
//       updatedDate,
//       updatedTime,
//       leadId: customerId,
//       name: customerData?.customername || "",
//       customerid: customerId,
//       collectionId: recoveryId,
//     };

//     // ✅ Create Task
//     const response = await axios.post(
//       apiUrl + "add-assign-task",
//       taskToSubmit,
//       { headers: { "Content-Type": "application/json" } }
//     );
//     const savedId = response.data?.data?._id;

//     // ✅ Send Notifications
//     try {
//       // 🔔 Notify Assigned Staff
//       await Promise.all(
//         selectedStaff.map(async (staff) => {
//           const title = `New Task: ${taskData.taskName}`;
//           const body = `You've been assigned a new task by ${staffName}`;
//           await sendNotification(title, body, staff._id, staff.staffName);
//         })
//       );

//       // 🔔 Notify Approvers
//       await Promise.all(
//         selectedApprover.map(async (staff) => {
//           const title = `Approval Required: ${taskData.taskName}`;
//           const body = `You need to approve a task assigned by ${staffName}. Assigned to: ${selectedStaff
//             .map((s) => s.staffName)
//             .join(", ")}`;
//           await sendNotification(title, body, staff._id, staff.staffName);
//         })
//       );
//     } catch (notificationError) {
//       console.warn("Notification sending failed:", notificationError);
//       Swal.fire({
//         icon: "info",
//         title: "Task Created",
//         text: "Task created but some notifications may not have been delivered",
//         timer: 2000,
//         showConfirmButton: false,
//       });
//     }

//     // ✅ Add Message (History)
//     const formData = new FormData();
//     formData.append("pageRefId", savedId);
//     formData.append("page", "Task");
//     formData.append("colorCode", "#fbdc6e");
//     formData.append("description", taskData.description);
//     formData.append("staffPic", "");
//     if (selectedFile) {
//       formData.append("image", selectedFile);
//     }
//     formData.append("updatesHistory[staff][name]", staffName);
//     formData.append("updatesHistory[staff][id]", Id);
//     formData.append("updatesHistory[status]", "Open");

//     await axios.post(apiUrl + "add-message", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });

//     // ✅ Fetch Messages
//     const msgRes = await axios.get(`${apiUrl}messages/${savedId}`);
//     setMessageData(msgRes.data.data);
//     setShowMessageBox(true);

//     // ✅ Final Success Popup
//     Swal.fire({
//       title: "Task Created Successfully!",
//       icon: "success",
//     }).then(() => {
//       setIsOpenAssign(false);
//       navigate("/task");
//     });
//   } catch (error) {
//     console.error("Task submission failed:", error);
//     Swal.fire({
//       icon: "error",
//       title: "Oops...",
//       text: error.response?.data?.message || "Something went wrong!",
//     });
//   }
// };
  
  const getFutureDateTime = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() + 1); // add 1 minute to current time
  return now.toISOString().slice(0, 16); // returns 'YYYY-MM-DDTHH:MM'
};


  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        staffDropdownRef.current &&
        !staffDropdownRef.current.contains(event.target)
      ) {
        setIsStaffDropdownOpen(false);
      }
      if (
        approverDropdownRef.current &&
        !approverDropdownRef.current.contains(event.target)
      ) {
        setIsApproverDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  //getmapInfo api to get the 5 table collection data in one api
  const [data, setData] = useState([]);
  useEffect(() => {
    // Fetch data from backend API
    const fetchData = async () => {
      try {
        const response = await axios.get(`${apiUrl}/consolidated-data`);
        setData(response.data); // Update state with the fetched data
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Failed to load data");
      }
    };

    fetchData();
  }, []);

  // 🔁 Fetch router types on mount
  useEffect(() => {
    const fetchMaterialTypes = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${apiUrl}manage-stock/get-material-type`
        );

        // Extract just the materialType strings from the response
        const types = response.data.map((item) => item.materialType);

        setRouterTypes(types);
        setRouterError(null);
      } catch (err) {
        console.routerError("Error fetching material types:", err);
        setError(
          err.response?.data?.message || "Failed to load material types"
        );
        setRouterTypes([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMaterialTypes();
  }, []);

  return (
    <div>
      <Topbar />
      <Container fluid className="mt-1">
        <Row>
          <Col>
            <h3>Recovery</h3>
          </Col>
          <Col className="text-end me-5">
            {/* Assign Task Popup */}
            {isOpenAssign && (
              <div className="overlay3">
                <div className="modal3">
                  <Container>
                    <div className="text-end mx-2">
                      <button
                        type="button"
                        className="black-btn mx-3"
                        onClick={() => setIsOpenAssign(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="blue-btn mx-3"
                        onClick={handleSubmitAssignTask}
                      >
                        Submit
                      </button>
                    </div>

                    <Row className="mt-4">
                      <Col xs={12} md={6}>
                        <Row>
                          <Col xs={12} md={6} className="text-start">
                            <label>Task Name</label>
                            <br />
                            <input
                              type="text"
                              className="form-input"
                              value={taskData.taskName}
                              readOnly
                            />
                          </Col>
                          <Col xs={12} md={6} className="text-start">
                            <label>Assign Date/Time</label>
                            <br />
                            <input
                              type="datetime-local"
                              className="form-input"
                                min={getFutureDateTime()} // optional: restrict past values

                              value={taskData.assignDateTime}
                              onChange={(e) =>
                                handleTaskChange(
                                  "assignDateTime",
                                  e.target.value
                                )
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col>
                        <Row>
                          {/* <Col xs={12} md={6} className="text-start">
                            <label>Task Type</label>
                            <br />
                            <input
                              type="text"
                              value={taskData.taskType}
                              className="form-input"
                              onChange={(e) =>
                                handleTaskChange("taskType", e.target.value)
                              }
                            />
                          </Col> */}
                          <Col xs={12} md={6} className="text-start">
                            <label>Task Priority</label>
                            <br />
                            <input
                              type="text"
                              value={taskData.taskPriority}
                              className="form-input"
                              onChange={(e) =>
                                handleTaskChange("taskPriority", e.target.value)
                              }
                            />
                          </Col>
                          <Col xs={12} md={6} className="text-start">

                            <label>Deadline Dtae/Time</label>

                            <br />
                            <input
                              type="datetime-local"
                              className="form-input overlay2"
                              value={taskData.deadline}
                                min={getFutureDateTime()} // only allows strictly future times

                              onChange={(e) =>
                                handleTaskChange("deadline", e.target.value)
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} md={6}>
                        <Row>
                            <Col xs={12} md={6} className="text-start">
                            <label>Customer ID</label>
                            <br />
                            <input
                              type="text"
                              className="form-input overlay2"
                              value={customerId}
                              readOnly
                            />
                          </Col>
                          
                          {/* <Col xs={12} md={6} className="text-start">
                            <label>Time</label>
                            <br />
                            <input
                              type="time"
                              className="form-input overlay2"
                              value={taskData.time}
                              onChange={(e) =>
                                handleTaskChange("time", e.target.value)
                              }
                            />
                          </Col> */}
                        </Row>
                      </Col>
                      <Col>
                        <Row>
                          <Col xs={12} md={6} className="text-start mt-2">
                            <label>Task Assign To</label>
                            <br />
                            <div
                              ref={staffDropdownRef}
                              style={{ position: "relative", width: "85%" }}
                            >
                              <div
                                onClick={toggleStaffDropdown}
                                style={{
                                  padding: "10px",
                                  border: "2px solid #a7a7a7",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  backgroundColor: "#fff",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "10px",
                                }}
                              >
                                <span
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {getStaffDisplayText()}
                                </span>
                                <span>{isStaffDropdownOpen ? "▲" : "▼"}</span>
                              </div>

                              {isStaffDropdownOpen && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    marginTop: "5px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                    zIndex: 1000,
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {staffData.length === 0 ? (
                                    <div
                                      style={{
                                        padding: "10px",
                                        color: "#888",
                                        textAlign: "center",
                                      }}
                                    >
                                      No staff found
                                    </div>
                                  ) : (
                                    staffData
                                      .filter((staff) =>
                                        [
                                          "Fiber Engineer",
                                          "Network Engineer",
                                          "Marketing/Fiber",
                                          "Marketing Executive",
                                        ].includes(staff.designation)
                                      )
                                      .map((staff) => (
                                        <label
                                          key={staff._id}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #eee",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedStaff.some(
                                              (s) => s._id === staff._id
                                            )}
                                            onChange={() =>
                                              handleStaffSelection(staff)
                                            }
                                            style={{ marginRight: "10px" }}
                                          />
                                          {staff.staffName }
                                        </label>
                                      ))
                                  )}
                                </div>
                              )}
                            </div>
                          </Col>
                          <Col xs={12} md={6} className="text-start mt-2">
                            <label>Approve Person</label>
                            <br />
                            <div
                              ref={approverDropdownRef}
                              style={{
                                position: "relative",
                                width: "85%",
                                marginTop: "15px",
                              }}
                            >
                              <div
                                onClick={toggleApproverDropdown}
                                style={{
                                  padding: "10px",
                                  border: "2px solid #a7a7a7",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                  backgroundColor: "#fff",
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                  marginTop: "-5px",
                                }}
                              >
                                <span
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {getApproverDisplayText()}
                                </span>
                                <span>
                                  {isApproverDropdownOpen ? "▲" : "▼"}
                                </span>
                              </div>

                              {isApproverDropdownOpen && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "100%",
                                    left: 0,
                                    right: 0,
                                    marginTop: "5px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
                                    zIndex: 1000,
                                    maxHeight: "200px",
                                    overflowY: "auto",
                                  }}
                                >
                                  {staffNameFetch.length === 0 ? (
                                    <div
                                      style={{
                                        padding: "10px",
                                        color: "#888",
                                        textAlign: "center",
                                      }}
                                    >
                                      No staff found
                                    </div>
                                  ) : (
                                    staffNameFetch.map((staff) => (
                                      <label
                                        key={staff._id}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          padding: "10px",
                                          cursor: "pointer",
                                          borderBottom: "1px solid #eee",
                                        }}
                                      >
                                        <input
                                          type="checkbox"
                                          name="approver"
                                          checked={selectedApprover.some(
                                            (s) => s._id === staff._id
                                          )}
                                          onChange={() =>
                                            handleApproverSelection(staff)
                                          }
                                          style={{ marginRight: "10px" }}
                                        />
                                        {staff.staffName}
                                      </label>
                                    ))
                                  )}
                                </div>
                              )}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={6} className="text-start">
                        <label>Description</label>
                        <br />
                        <textarea
                          className="form-input inputfield-assign"
                          placeholder="Enter Notes"
                          value={taskData.description}
                          onChange={(e) =>
                            handleTaskChange("description", e.target.value)
                          }
                          style={{
                            textTransform: "capitalize",
                            resize: "none",
                          }}
                        />
                      </Col>
                      <Col>
                        <Row>
                          {/* custmer id */}
                          <Col xs={12} md={6} className="text-start">
                            <label>Customer Name</label>
                            <br />
                            <input
                              type="text"
                              className="form-input"
                              value={customerData?.customername || ""}
                              readOnly
                              style={{ textTransform: "capitalize" }}
                            />
                          </Col>
                          <Col xs={12} md={6} className="text-start">
                            <label>Task Status</label>
                            <br />
                            <input
                              type="text"
                              className="form-input"
                              value={taskData.taskStatus}
                              readOnly
                              style={{
                                textTransform: "capitalize",
                                backgroundColor: "#fbdc6e",
                                color: "rgb(94, 94, 14)",
                              }}
                            />
                          </Col>
                        </Row>
                        <Row>{/* open status */}</Row>
                      </Col>
                    </Row>
                  </Container>
                </div>
              </div>
            )}

            {/* Form action buttons */}
            {!isSubmitted && !isEditMode && (
              <button className="blue-btn my-1" onClick={handleRecoverySubmit}>
                Submit
              </button>
            )}

            {isSubmitted && !isEditMode && (
              <>
                <button
                  className="black-btn mx-1 my-1"
                  onClick={() => {
                    setOriginalRecovery(
                      JSON.parse(JSON.stringify(recoveryData))
                    );
                    setIsEditMode(true);
                  }}
                >
                  <MdEdit className="mx-1 editicon-recovery" />
                  Edit
                </button>
                <button
                  className="blue-btn my-1"
                  onClick={() => {
                    setTaskData((prev) => ({
                      ...prev,
                      leadId: customerId,
                      name: customerData?.customername || "",
                    }));
                    setIsOpenAssign(true);
                  }}
                >
                  <MdOutlineAssignmentInd className="mx-1 editicon-recovery" />
                  Assign
                </button>
              </>
            )}

            {isEditMode && (
              <>
                <button className="blue-btn my-1" onClick={handleSave}>
                  Save
                </button>
                <button className="black-btn mx-1 my-1" onClick={handleCancel}>
                  Cancel
                </button>
              </>
            )}
          </Col>
        </Row>

        <div className="border-container1">
          <h6 className="form-head m-0 text-white text-center">Add Recovery</h6>
        </div>
        <div className="border-container">
          <form>
            <Row className="text-start lead-id-row mb-4 mt-4 ms-4">
              <p className="ps-5 paragraph-lead-id">
                <span className="lead-start-date-recovery">
                  Lead Started Date -
                  <span className="text-primary">
                    {recoveryData?.createdDate || currentDate}
                  </span>
                </span>
              </p>
            </Row>

            <Row className="ms-3">
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <label>Customer Id *</label>
                    <br />
                    <input
                      type="text"
                      name="customerid"
                      className="form-input"
                      placeholder="Enter Customer Id"
                      value={customerId}
                      onChange={(e) => {
                        setCustomerId(e.target.value);
                        handleRecoveryChange(e);
                      }}
                      readOnly={isSubmitted && !isEditMode}
                    />
                    {error && <p className="customer-id-error mb-1">{error}</p>}
                  </Col>

                  <Col sm={12} md={6} className="text-start">
                    <label>Customer Name *</label>
                    <br />
                    <input
                      type="text"
                      className="form-input"
                      placeholder="Enter Customer Name"
                      name="customername"
                      value={recoveryData.customername || ""}
                      onChange={handleRecoveryChange}
                      readOnly={isSubmitted && !isEditMode}
                      style={{ textTransform: "capitalize" }}
                    />
                  </Col>
                </Row>
                <Row className="">
                  <Col xs={12} md={12} className="text-start">
                    <label>Address</label>
                    <br />
                    <textarea
                      className="box-recovery"
                      placeholder="Enter Address"
                      name="address"
                      value={recoveryData.address || ""}
                      onChange={handleRecoveryChange}
                      readOnly={isSubmitted && !isEditMode}
                      style={{ textTransform: "capitalize", resize: "none" }}
                    />
                  </Col>
                </Row>
              </Col>
              <Col>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <label>
                      Contact Number
                      <sup>
                        <FaStarOfLife size={7} />
                      </sup>
                    </label>
                    <br />
                    <input
                      type="tel"
                      className="form-input"
                      placeholder="Enter Phone Number"
                      name="contactnum"
                      maxLength={10}
                      value={recoveryData.contactnum || ""}
                      onChange={handleRecoveryChange}
                      required
                      readOnly={isSubmitted && !isEditMode}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Col>

                  <Col xs={12} md={6} className="text-start">
                    <label>Alternate Number</label>
                    <br />
                    <input
                      type="tel"
                      className="form-input"
                      placeholder="Enter Phone Number"
                      name="alternatenum"
                      maxLength={10}
                      value={recoveryData.alternatenum || ""}
                      onChange={handleRecoveryChange}
                      readOnly={isSubmitted && !isEditMode}
                      onKeyDown={(e) => {
                        if (
                          ["e", "E", "+", "-"].includes(e.key) ||
                          (e.key &&
                            !/[0-9]/.test(e.key) &&
                            e.key !== "Backspace" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight")
                        ) {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} md={6} className="text-start">
                    <label>Location *</label>
                    <br />
                    <input
                      className="form-input"
                      placeholder="Enter Location"
                      name="location"
                      value={recoveryData?.location || ""}
                      onChange={handleRecoveryChange}
                      readOnly={isSubmitted && !isEditMode}
                      style={{ textTransform: "capitalize" }}
                    />
                    {errorLocation && (
                      <p className="customer-id-error mb-1">{errorLocation}</p>
                    )}
                  </Col>
                  <Col xs={12} md={6} className="text-start">
                    <label>Area *</label>
                    <br />
                    <input
                      className="form-input"
                      placeholder="Enter area"
                      name="area"
                      value={recoveryData.area || ""}
                      onChange={handleRecoveryChange}
                      readOnly={isSubmitted && !isEditMode}
                      style={{ textTransform: "capitalize" }}
                    />
                  </Col>
                  <Row>
                    <Col xs={12} md={6} className="text-start">
                      <label>Router Type *</label>
                      <br />
                      {loading ? (
                        <p>Loading material types...</p>
                      ) : routerError ? (
                        <p className="text-danger">{routerError}</p>
                      ) : (
                        <select
                          className="dropbtn form-input-select"
                          name="routertype"
                          value={recoveryData?.routertype || ""}
                          onChange={handleRecoveryChange}
                          disabled={isSubmitted && !isEditMode}
                        >
                          <option value="">Select</option>
                          {routerTypes.map((type, index) => (
                            <option key={index} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      )}
                    </Col>

                    <Col xs={12} md={6} className="text-start">
                      <Row className="ms-2">
                        <label>Recovery Status</label>
                        <br />
                        <input
                          type="button"
                          className="form-input converted-form"
                          name="leadStatus"
                          value="Open"
                          onClick={() => setIsOpenConverted(true)}
                          disabled={isSubmitted && !isEditMode}
                          style={{
                            textTransform: "capitalize",
                            backgroundColor: "#fbdc6e",
                            color: "rgb(94, 94, 14)",
                          }}
                        />
                        {isOpenConverted && (
                          <div className="overlay1-converted">
                            <div className="modal1-converted-recovery">
                              <Container>
                                <button
                                  className="close-btn1-recovery"
                                  onClick={() => setIsOpenConverted(false)}
                                >
                                  <span style={{ fontSize: "20px" }}>
                                    &times;
                                  </span>
                                </button>

                                <div className="open-button border">
                                  <h5
                                    style={{
                                      textTransform: "capitalize",
                                      color: " rgb(70, 31, 31)",
                                    }}
                                  >
                                    Open
                                  </h5>
                                </div>

                                <textarea
                                  className="converted-textbox"
                                  placeholder="Enter Notes"
                                  name="recoverynotes"
                                  value={
                                    recoveryData?.recoveryleadStatus
                                      ?.recoverynotes || ""
                                  }
                                  onChange={handleRecoveryChange}
                                  readOnly={isSubmitted && !isEditMode}
                                  style={{
                                    textTransform: "capitalize",
                                    resize: "none",
                                  }}
                                />
                               <div className="upload-section">
                                <label className="upload-btn">
                                  <FiUpload className="upload-icon" />
                                  Upload Image
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleFileChange}
                                    hidden
                                  />
                                </label>
                                {selectedFile && (
                                  <p className="file-name">
                                    {selectedFile.name}
                                  </p>
                                )}
                              </div>

                                <Row>
                                  <Col className="date-update-textbox">
                                    <label>Next Follow Up Date</label>
                                    <br />
                                    <input
                                      type="date"
                                      className="field form-input"
                                      name="nextFollowUpDate"
                                      value={
                                        recoveryData?.recoveryleadStatus
                                          ?.nextFollowUpDate || ""
                                      }
                                      onChange={handleRecoveryChange}
                                      readOnly={isSubmitted && !isEditMode}
                                    />
                                  </Col>
                                  <Col className="uploadbtn-install">
                                    <button
                                      type="button"
                                      className="blue-btn"
                                      onClick={() => setIsOpenConverted(false)}
                                      disabled={isSubmitted && !isEditMode}
                                    >
                                      Upload
                                    </button>
                                  </Col>
                                </Row>
                              </Container>
                            </div>
                          </div>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Row>
              </Col>
            </Row>
          </form>
        </div>
        {showMessageBox && (
          <Row className="container ms-3  me-5">
            <Col md={6} sm={12}>
              <div>
                {messageData &&
                  messageData.map((msg) => (
                    <MessageBox key={msg._id} message={msg} />
                  ))}{" "}
              </div>
            </Col>
            <Col md={6} sm={12} className="">
              {/* Updates History Section */}
              <div className="compact-updates-history">
                <div className="compact-updates-header"> Updates History </div>
                {messageData &&
                  messageData.map((data, index) => (
                    <div className="compact-update text-center" key={index}>
                      <div className="compact-update-date text-center">
                        {new Date(data.updatesHistory.date).toLocaleDateString(
                          "en-GB"
                        ) +
                          " - " +
                          new Date(data.updatesHistory.date)
                            .toLocaleTimeString("en-US", {
                              hour: "2-digit",
                              minute: "2-digit",
                              hour12: true,
                            })
                            .replace(":", ".")}
                      </div>

                      <div className="compact-update-user text-center">
                        {" "}
                        {data.updatesHistory.staff?.name}{" "}
                      </div>
                      <div
                        className={"compact-update-status text-center "}
                        style={{
                          color: data.colorCode ? data.colorCode : "#000000",
                        }}
                      >
                        {data.updatesHistory.status}
                      </div>
                    </div>
                  ))}
              </div>
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
};

export default AddRecovery;
